<template>
  <b-modal
    id="ro-delivery-warning-modal"
    ref="ro-delivery-warning-modal"
    class="mc-modal"
    size="md"
    centered
    hide-header-close
    no-close-on-esc
    no-close-on-backdrop
    :title="$t('routeOptimization.modal.notOptimized.title')"
  >
    <div class="card-body p-2">
      <McAlert withIcon class="w-100 mb-3" variant="warning">
        <template #label>
          <span
            v-html="
              $t('routeOptimization.modal.notOptimized.alert', {
                totalUnserved: totalUnserved,
                totalDO: totalDeliveryOrder,
              })
            "
          />
        </template>
      </McAlert>
      <p>
        {{ $t('routeOptimization.modal.notOptimized.desc') }}
      </p>
    </div>
    <template #modal-footer="{ cancel }">
      <div class="d-flex mx-0">
        <McButton
          variant="secondary"
          class="me-2"
          :text="$t('routeOptimization.modal.notOptimized.action.close')"
          @click="handleClose(cancel)"
        />
        <McButton
          variant="primary"
          :text="$t('routeOptimization.modal.notOptimized.action.viewDetail')"
          @click="handleViewDetails"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McAlert from '@/components/McAlert'
import McButton from '@/components/McButton'

import { mapState } from 'vuex'

export default {
  name: 'DeliveryWarningModal',
  components: {
    McAlert,
    McButton,
  },
  emits: ['close', 'viewDetails'],
  computed: {
    ...mapState('routeOptimization', ['unservedShowResponse']),
    totalUnserved() {
      return this.unservedShowResponse?.metadata?.total_unserved
    },
    totalDeliveryOrder() {
      return (
        this.unservedShowResponse?.metadata?.total_served +
        this.unservedShowResponse?.metadata?.total_unserved
      )
    },
  },
  methods: {
    handleClose(cancel) {
      cancel()
      this.$emit('close')
    },

    handleViewDetails() {
      this.$bvModal.hide('ro-delivery-warning-modal')
      this.$emit('viewDetails')
    },
  },
}
</script>
